<!-- Navigation -->
<ul class="navbar-nav">
  <li>
    <a routerLink="/vacancy-search" class="nav-link" routerLinkActive="active">
      <fa-icon [icon]="faBinoculars"></fa-icon>
      Advertised Vacancies
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/applications" class="nav-link">
      <fa-icon [icon]="faListCheck"></fa-icon> Applications
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/users" class="nav-link" routerLinkActive="active" aria-current="page">
      <fa-icon [icon]="faPeopleGroup"></fa-icon>
      Users
    </a>
  </li>
</ul>

<!-- Divider -->
<hr class="navbar-divider my-3">

<!-- Heading -->
<h6 class="navbar-heading">
  Manage
</h6>

<ul class="navbar-nav">
  <li>
    <a routerLink="/vacancies" class="nav-link" routerLinkActive="active">
      <fa-icon [icon]="faBinoculars"></fa-icon>
      Vacancies
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/individuals" class="nav-link">
      <fa-icon [icon]="faPeople"></fa-icon> Employees
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/people-partners" class="nav-link" routerLinkActive="active" aria-current="page">
      <fa-icon [icon]="faPeopleGroup"></fa-icon>
      People Partners
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/projects" class="nav-link" routerLinkActive="active" aria-current="page">
      <fa-icon [icon]="faChartMixed"></fa-icon>
      Projects
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/applications/questions" class="nav-link">
      <fa-icon [icon]="faListCheck"></fa-icon> Application Questions
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/applications/forms" class="nav-link">
      <fa-icon [icon]="faListCheck"></fa-icon> Application Forms
    </a>
  </li>
  <li class="nav-item">
    <a routerLink="/email-templates" class="nav-link" routerLinkActive="active" aria-current="page">
      <fa-icon [icon]="faEnvelope"></fa-icon>
      Email Templates
    </a>
  </li>
</ul>
